"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransmissionCodec = exports.buildSystemTransmission = exports.SystemTransmissionCodec = exports.buildApplicationTransmission = exports.ApplicationTransmissionCodec = exports.buildChainMessage = exports.buildRegularMessage = exports.ApplicationMessageCodec = exports.RegularMessageCodec = exports.ChainMessageCodec = exports.SystemMessageCodec = exports.buildKeepAlivePingMessage = exports.KeepAlivePingMessageCodec = exports.buildDropChainMessage = exports.DropChainMessageCodec = exports.buildTerminateConnectionMessage = exports.TerminateConnectionMessageCodec = exports.buildAuthStatusMessage = exports.AuthStatusMessageCodec = exports.buildAuthResponseMessage = exports.AuthResponseMessageCodec = exports.buildAuthChallengeMessage = exports.AuthChallengeMessageCodec = exports.SystemMessageType = exports.TransmissionType = void 0;
const t = __importStar(require("io-ts"));
var TransmissionType;
(function (TransmissionType) {
    /**
     * Marks a transmission that's invisible to application code, and is used for bookkeeping in the
     * underlying messenger implementation.
     */
    TransmissionType["System"] = "System";
    /**
     * Transmissions of this type contain one or more messages created by application-level code.
     */
    TransmissionType["Application"] = "Application";
})(TransmissionType = exports.TransmissionType || (exports.TransmissionType = {}));
var SystemMessageType;
(function (SystemMessageType) {
    SystemMessageType["AuthChallenge"] = "AuthChallenge";
    SystemMessageType["AuthResponse"] = "AuthResponse";
    SystemMessageType["AuthStatus"] = "AuthStatus";
    SystemMessageType["TerminateConnection"] = "TerminateConnection";
    SystemMessageType["DropChain"] = "DropChain";
    SystemMessageType["KeepAlivePing"] = "KeepAlivePing";
})(SystemMessageType = exports.SystemMessageType || (exports.SystemMessageType = {}));
// ------------------------------------------------------------------------------------------
exports.AuthChallengeMessageCodec = t.type({
    type: t.literal(SystemMessageType.AuthChallenge),
    challengeData: t.unknown,
});
exports.buildAuthChallengeMessage = (challengeData) => ({
    type: SystemMessageType.AuthChallenge,
    challengeData,
});
exports.AuthResponseMessageCodec = t.type({
    type: t.literal(SystemMessageType.AuthResponse),
    responseData: t.unknown,
});
exports.buildAuthResponseMessage = (responseData) => ({
    type: SystemMessageType.AuthResponse,
    responseData,
});
exports.AuthStatusMessageCodec = t.type({
    type: t.literal(SystemMessageType.AuthStatus),
    success: t.boolean,
    message: t.string,
});
exports.buildAuthStatusMessage = (success, message) => ({
    type: SystemMessageType.AuthStatus,
    success,
    message,
});
exports.TerminateConnectionMessageCodec = t.type({
    type: t.literal(SystemMessageType.TerminateConnection),
    userTerminateMessage: t.string,
    shouldRetry: t.boolean,
});
exports.buildTerminateConnectionMessage = (userTerminateMessage, shouldRetry) => ({
    type: SystemMessageType.TerminateConnection,
    userTerminateMessage,
    shouldRetry,
});
exports.DropChainMessageCodec = t.type({
    type: t.literal(SystemMessageType.DropChain),
    namespace: t.string,
    channelID: t.string,
    chainID: t.string,
    chainKey: t.string,
});
exports.buildDropChainMessage = (namespace, channelID, chainID, chainKey) => ({
    type: SystemMessageType.DropChain,
    namespace,
    channelID,
    chainID,
    chainKey,
});
exports.KeepAlivePingMessageCodec = t.type({
    type: t.literal(SystemMessageType.KeepAlivePing),
});
exports.buildKeepAlivePingMessage = () => ({
    type: SystemMessageType.KeepAlivePing,
});
exports.SystemMessageCodec = t.union([
    exports.AuthChallengeMessageCodec,
    exports.AuthResponseMessageCodec,
    exports.AuthStatusMessageCodec,
    exports.TerminateConnectionMessageCodec,
    exports.DropChainMessageCodec,
    exports.KeepAlivePingMessageCodec,
]);
// ------------------------------------------------------------------------------------------
exports.ChainMessageCodec = t.type({
    chain: t.literal(true),
    chainKey: t.string,
    chainIndex: t.number,
    namespace: t.string,
    channelID: t.string,
    chainID: t.string,
    payload: t.unknown,
});
exports.RegularMessageCodec = t.type({
    chain: t.literal(false),
    namespace: t.string,
    channelID: t.string,
    messageID: t.string,
    payload: t.unknown,
});
exports.ApplicationMessageCodec = t.union([exports.ChainMessageCodec, exports.RegularMessageCodec]);
exports.buildRegularMessage = (namespace, channelID, messageID, payload) => ({
    chain: false,
    namespace,
    channelID,
    messageID,
    payload,
});
exports.buildChainMessage = (chainKey, chainIndex, namespace, channelID, chainID, payload) => ({
    chain: true,
    chainKey,
    chainIndex,
    namespace,
    channelID,
    chainID,
    payload,
});
// ------------------------------------------------------------------------------------------
exports.ApplicationTransmissionCodec = t.type({
    type: t.literal(TransmissionType.Application),
    payload: t.array(exports.ApplicationMessageCodec),
});
exports.buildApplicationTransmission = (payload) => ({
    type: TransmissionType.Application,
    payload,
});
exports.SystemTransmissionCodec = t.type({
    type: t.literal(TransmissionType.System),
    payload: exports.SystemMessageCodec,
});
exports.buildSystemTransmission = (payload) => ({
    type: TransmissionType.System,
    payload,
});
// ------------------------------------------------------------------------------------------
/**
 * A transmission is the highest-level of abstraction of objects that are sent over the websocket.
 * Everything that is sent over the socket must be a Transmission.
 */
exports.TransmissionCodec = t.readonly(t.union([exports.SystemTransmissionCodec, exports.ApplicationTransmissionCodec]));
//# sourceMappingURL=TransmissionTypes.js.map